/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSelector } from "react-redux";
import { selectFieldSchema } from "data/store/reducers/schema-model";
import { Logger } from "cms/utils/log/logger";

/**
 * Gets a field schema from the current model
 * @param {string} fieldName
 * @param {string} propertyName
 */
export function useSelectFieldSchemaProperty (fieldName, propertyName) {
    const schema = useSelector((state) => {
        return selectFieldSchema(state, fieldName);
    });
    
    if (!schema) {
        Logger.warn(`[useSelectFieldSchemaProperty] [${fieldName}] [${propertyName}]. schema is undefined`);
        return undefined;
    }
    
    const property = schema[propertyName];
    
    return property;
}
